import { FC } from 'react';

import { AlienIcon } from '@smartshell/ui-kit';
import cn from 'classnames';

import { getRoleIcon } from 'utils';

import s from './ClientsAvatar.module.scss';
import { IClientsAvatarProps } from './interfaces';

export const ClientsAvatar: FC<IClientsAvatarProps> = ({
  avatar,
  roles,
  size = 'm',
}) => {
  return (
    <div className={cn(s.header_avatar, size && s[size])}>
      {avatar ? (
        <img className={s.header_image} src={avatar} alt="avatar" />
      ) : (
        <AlienIcon className={s.alien_icon} color="disable" />
      )}
      {roles?.length !== 0 && (
        <div className={s.header_role}>{getRoleIcon(roles || [])}</div>
      )}
    </div>
  );
};
